import type { SearchEntryCategorySB, SearchEntryChampionshipSB, SearchEntrySportSB } from '@mwl/core-lib';

import { routes } from '@/constants';

import type { ExtendedEntity } from './SportSearchResult.types';

export const getAnalytics = (
  variant: 'sports' | 'categories' | 'championships',
  searchResult: ExtendedEntity<SearchEntryChampionshipSB | SearchEntryCategorySB | SearchEntrySportSB>,
) => {
  const variantMap = {
    championships: 'sport_searchResult_championships_click',
    categories: 'sport_searchResult_category_click',
    sports: 'sport_searchResult_sport_click',
  };

  return {
    click: {
      eventName: variantMap[variant],
      data: {
        sport_category: searchResult?.hrefQuery?.sch,
        search_request: searchResult?.title,
        href: `${routes.sport.home}/${searchResult?.hrefQuery}`,
      },
    },
  };
};

export const analyticsBtn = {
  click: {
    eventName: 'sport_searchResult_sport_showMore_btn_click',
  },
};
